// extracted by mini-css-extract-plugin
module.exports = {"cont":"MyPageCompanyCreateOtherInput_cont__2A7lh","box":"MyPageCompanyCreateOtherInput_box__Kd6fn","sm":"MyPageCompanyCreateOtherInput_sm__1y60O"};